import { InputAdornment, TextField } from "@mui/material";
import IconSearch from '@/assets/img/Icon_Search.svg'
import { useEffect, useState } from "react";
import styles from "./SearchFilter.module.css"
import { useSearchParams } from "next/navigation";
import { pushToDataLayer } from "@/utils/helpers";
export default function SearchFilter({ update, resetSignal }: { update: (name: string, value: string) => void, resetSignal: number}) {

	const params = useSearchParams();
	const initialSearch = params.get('search');
	// console.log('INITLA SEARCH: ', initialSearch)
	const [search, setSearch] = useState(initialSearch ? initialSearch : '')

	function handleChange(e:React.ChangeEvent<HTMLInputElement>) {
		setSearch(e.target.value)
	}

	useEffect(() => {
		const handler = setTimeout(() => {
			update('search', search === '' ? '' : 'search=' + search)
		}, 500) // 500ms debounce
		return () => clearTimeout(handler)
	}, [search])

	useEffect(() => {
		if(resetSignal !== 0) {
			setSearch('')
		}
	}, [resetSignal])

	return (
		<TextField label={'Search'}
			data-testid="catalogueSearch_input"
			value={search}
			onChange={handleChange}
			className={styles.textfield}
			slotProps={{
				input: {
					endAdornment:
					<InputAdornment position="end">
						<IconSearch width={'1.25rem'} height={'1.25rem'}/>
					</InputAdornment>
				}
			}}
		/>
	)
}